
import React, {  useMemo } from 'react';
import { DetalleGrupoActividadHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidoresPlanificacion, DetalleServidoresPlanificacionHE, NovedadesServidoresHEDTO, ParamsHorasMesPlanificacionHEDTO } from "./TypesPlanificacionHE";

import "../../../../assets/scss/Horas Extras/PlanificacionHorasExtras.scss"
import TableServidoresPlanHE from './TableServidoresPlanHE';

export type PropsServidoresPlanificacionHE = {
    estadoPlanificacion: string,
    listadoServidores: DetalleServidoresPlanificacionHE[],
    recargarInformacion: () => Promise<void>
    paramsHorasMesPlanificacionHE:ParamsHorasMesPlanificacionHEDTO[]
    novedadesServidores: NovedadesServidoresHEDTO[]
    mensajeNovedad: string
    regimenLaboralesPlan:DetalleRegimenLaboralHEDTO[];
    idUnidadAprueba: number
    puedeRealizarAccion?: boolean
    guardarParcial: () => void
    firmaryEnviar: () => Promise<void>
    solicitarReverso: () => void
    descargarResumenExcel: () => Promise<void>
    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;
    mostrarReporteResumenProyPlanifExcel?: boolean | undefined;
    loadingAccionReporteExcel: boolean,
    nombreUnidadAprueba?: string,
    gruposActividad: DetalleGrupoActividadHEDTO[];
    docPlanificacionUnidad?: string;
    idPlanificacionUnidad?: number;
}



export default function ServidoresPlanificacionHE(props: PropsServidoresPlanificacionHE) {
    const contenidoTablaServidores = useMemo(() => {
        const contenidoServidores = (
            <TableServidoresPlanHE 
                idUnidadAprueba={props.idUnidadAprueba}
                regimenLaboralesPlan={props.regimenLaboralesPlan} 
                servidoresPlan={props.listadoServidores}  
                recargarInformacion={props.recargarInformacion}
                paramsHorasMesPlanificacionHE={props.paramsHorasMesPlanificacionHE}
                novedadesServidores={props.novedadesServidores}
                estadoPlanificacion={props.estadoPlanificacion}
                mensajeNovedad = {props.mensajeNovedad}
                tipo='PL'
                puedeRealizarAccion={props.puedeRealizarAccion}
                guardarParcial = {props.guardarParcial}
                firmaryEnviar = {props.firmaryEnviar}
                solicitarReverso = {props.solicitarReverso}
                descargarResumenExcel={props.descargarResumenExcel}
                mostrarGuardarParcial = {props.mostrarGuardarParcial}
                mostrarFirmaryEnviar  = {props.mostrarFirmaryEnviar}
                mostrarSolicitarReverso = {props.mostrarSolicitarReverso}                
                mostrarReporteResumenProyPlanifExcel = {props.mostrarReporteResumenProyPlanifExcel}
                loadingAccionReporteExcel = {props.loadingAccionReporteExcel}
                nombreUnidadAprueba = {props.nombreUnidadAprueba}
                gruposActividad={props.gruposActividad}
                docPlanificacionUnidad={props.docPlanificacionUnidad}
                idPlanificacionUnidad={props.idPlanificacionUnidad}
            />
        )

        return contenidoServidores;
    }, [props.listadoServidores])

    return (
        <>
        {contenidoTablaServidores}
        </>
        
        

    )
}